const state = {
  report_basic: [],
  report_moneybox_unload_state: [],
}

const getters = {
  
}

const actions = {
  requestReportBasic({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {

      this._vm.$axios.get(api.reportsBasic()).then(function(response){
                  commit("_requestReportBasic", response.data)
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
  requestReportMoneyboxUnloadState({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {

      this._vm.$axios.get(api.reportsMoneyboxUnloadState()).then(function(response){
                  commit("_requestReportMoneyboxUnloadState", response.data)
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
}

const mutations = {
  _requestReportBasic(state, payload){
    state.report_basic = payload
  },
  _requestReportMoneyboxUnloadState(state, payload){
    state.report_moneybox_unload_state = payload
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
